<template>
    <div class="hello">
        <h1>About Page</h1>
        <h3>Đây là trang giới thiệu Mobile</h3>
      <div>
        <select class="seleclist" @change="change()">
          <option>Choose Color</option>
          <option value="news">Tin tức</option>
          <option value="story">Truyện hay</option>
          <option value="love">Cửa sổ tình yêu</option>
          <option value="health">Sức khỏe</option>
        </select>
      </div>

      <div class="tab-content">
        <div id="news" class="news tab-pane"><br>
          Tin tức
        </div>
        <div id="story" class="story tab-pane"><br>
          Truyện hay
        </div>
        <div id="love" class="love tab-pane"><br>
          Tình yêu
        </div>
        <div id="health" class="health tab-pane"><br>
          Sức khỏe
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'AboutMobile',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App abc xyz vvvvvv'
    }
  },
  mounted () {
    $(".news").show();
  },
  methods: {
    change(){
      var select = $(".seleclist");
      var s = select[0];
      $(s).find("option:selected").each(function(){
        var optionValue = $(this).attr("value");
        if(optionValue){
          $(".tab-pane").not("." + optionValue).hide();
          $("." + optionValue).show();
        } else{
          $(".tab-pane").hide();
        }
      });
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tab-pane{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/AboutMobile.vue